export const showErrorMessage = (error) => (
  <div className="col-9 offset-3 mt-1">
    <p className="msg-error m-0 p-0">{error}</p>
  </div>
);
